<template>
  <div class="page-container">
    <div class="infos-container">
      <!-- Choix du fournisseur -->
      <div class="white-box position-relative header">
        <TileLoader :loading="loading"/>
        <div>
          <Substitute class="substitute" :frsList="frsList" :selectedFrsGuid="selectedFrsGuid"
                      @update="substitute"></Substitute>
        </div>
        <div>{{ appointmentLabel }}</div>
        <div>{{ contractStatus }}</div>
      </div>

      <div class="tiles-container">
        <FrsInfosTile :recap="recap" :loading="loading"/>
        <FrsContactTile :frs-guid="selectedFrsGuid"/>
        <FrsPaymentsTile :frs-guid="selectedFrsGuid" />
        <FrsCaRfaInfosTile :frs-guid="selectedFrsGuid" />
        <FicheRdvRubriquesTile :frs-guid="selectedFrsGuid"/>
        <FrsPrestasTile :frs-guid="selectedFrsGuid" />
        <FrsGammesCaRfaInfosTile :frs-guid="selectedFrsGuid" />
        <FrsRulesRfaInfosTile :frs-guid="selectedFrsGuid" />
        <FrsCommentTile :frs-guid="selectedFrsGuid" />
      </div>
    </div>
  </div>
</template>

<script>

import Substitute from "@/components/Substitute";
import Modal from "@/components/Modal";
import FicheRdvRubriquesTile from "@/components/DashboardCdm/RecapPage/FicheRdvRubriquesTile";

import {getFrsList} from "@/utils/frs";
import TileLoader from "@/components/Dashboards/TileLoader.vue";
import {getRecapFrs} from "@/utils/dashboardCdm";
import dayjs from "dayjs";
import FrsInfosTile from "@/components/DashboardCdm/RecapPage/FrsInfosTile.vue";
import FrsContactTile from "@/components/DashboardCdm/RecapPage/FrsContactTile.vue";
import FrsPaymentsTile from "@/components/DashboardCdm/RecapPage/FrsPaymentsTile.vue";
import FrsCaRfaInfosTile from "@/components/DashboardCdm/RecapPage/FrsCaRfaInfosTile.vue";
import FrsGammesCaRfaInfosTile from "@/components/DashboardCdm/RecapPage/FrsGammesCaRfaInfosTile.vue";
import FrsRulesRfaInfosTile from "@/components/DashboardCdm/RecapPage/FrsRulesRfaInfosTile.vue";
import FrsPrestasTile from "@/components/DashboardCdm/RecapPage/FrsPrestasTile.vue";
import FrsCommentTile from "@/components/DashboardCdm/RecapPage/FrsCommentTile.vue";

export default {
  name: "RecapFournisseur",
  components: {
    FrsPrestasTile,
    FrsRulesRfaInfosTile,
    FrsGammesCaRfaInfosTile,
    FrsCaRfaInfosTile,
    FrsPaymentsTile, FrsContactTile, FrsInfosTile, TileLoader, Substitute, Modal, FicheRdvRubriquesTile, FrsCommentTile},
  props: [],
  data() {
    return {
      // gestion substitute
      loading: 0,
      frsList: [],
      selectedFrsGuid: "",

      recap: null,
    }
  },
  mounted() {
    const urlFrsGuid = this.$route.query.frsGuid;
    if (urlFrsGuid) {
      this.selectedFrsGuid = urlFrsGuid;
      this.substitute(urlFrsGuid);
    }

    this.initFrsList();
    this.initFrsRecap();
  },
  methods: {
    dayjs,
    // Chargement de la page
    initFrsList() {
      if (this.frsList.length == 0) {
        this.loading += 1;
        getFrsList(null, false).then(res => {
          this.frsList = res;
          this.loading -= 1;
        });
      }
    },

    initFrsRecap() {
      this.loading += 1;
      getRecapFrs(this.selectedFrsGuid).then(res => {
        this.loading -= 1;
        if (res && res.length > 0) {
          this.recap = res[0];
        }
      })
    },

    // Changement de fournisseur
    substitute(guid) {
      if (guid != this.selectedFrsGuid) {
        this.$router.push({
          query: {
            frsGuid: guid
          }
        })
      }
    },

    // Formattage des pourcentages
    formatNbPercent(n) {
      return n.toLocaleString("fr-FR", {style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2})
    },

    // Formattage des nombres
    formatNbInt(n) {
      return n.toLocaleString("fr-FR", {maximumFractionDigits: 0});
    },
  },
  computed: {
    appointmentLabel() {
      if (!this.recap || !this.recap.Appointment) return "Aucun rendez-vous";
      let res = "Rendez-vous ";
      let isPast = dayjs(this.recap.Appointment).isBefore(dayjs(), "day");

      res += isPast ? "passé : " : "planifié : ";
      res += dayjs(this.recap.Appointment).fromNow();
      res += " (" + dayjs(this.recap.Appointment).format("dddd DD/MM/YYYY [à] HH:mm") + ")";
      return res;
    },
    contractStatus() {
      let labels = {
        1: "Contrat créé",
        2: "Contrat initié",
        3: "Contrat en négociations",
        4: "Contrat pré-validé",
        6: "Contrat validé CMEM",
        7: "Contrat signé CMEM",
        8: "Contrat finalisé",
        10: "Contrat abandonné",
        11: "Contrat de brouillon"
      }

      if (!this.recap || !this.recap.ContractStatus) return "";

      return labels[this.recap.ContractStatus];
    }
  }
}
</script>

<style scoped>
.white-box {
  padding: 12px;
}

h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.infos-container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.header {
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  column-gap: 12px;
  align-items: center;
}

.header .substitute {
  width: max-content;
}

.header > *:nth-child(3) {
  text-align: right;
}

.tiles-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Achat/DashboardCdm/RecapFournisseur.vue